import React from 'react'
import { withStyles } from '@mui/styles'

const PhotoTan = props => {
  const { classes, mime, content } = props

  return (
    <div className={classes.root}>
      <img src={`data:${mime};base64,${content}`} alt="PhotoTAN" className={classes.image} />
    </div>
  )
}

PhotoTan.defaultProps = {
  mime: 'image/png',
}

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  image: {
    width: 192,
    height: 192,
    borderRadius: 8,
    border: '12px solid #000',
    padding: 1,
  },
}

export default withStyles(styles)(PhotoTan)
